export enum InsuranceType {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    SELF_PAYER = 'SELF_PAYER',
}
